import { Card } from "../../../../shared";

/**
 * Bordered section wrapper for equipment show panels.
 */
export const SectionCard = ({ title, description, actions, children, className = "" }) => (
  <Card className={`bg-white rounded-lg shadow-sm p-4 md:p-5 ${className}`}>
    {(title || actions) && (
      <div className="mb-4 flex flex-wrap items-start justify-between gap-2 border-b border-gray-100 pb-3">
        <div>
          {title ? (
            <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
          ) : null}
          {description ? (
            <p className="mt-1 text-sm text-gray-500">{description}</p>
          ) : null}
        </div>
        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </div>
    )}
    {children}
  </Card>
);

export default SectionCard;
